import React from "react";
import ReactDOM from "react-dom";
import Helmet from "react-helmet";
import paypal from "paypal-checkout";
import { connect } from "react-redux";
import { authActions } from "../../../core/auth";
import ReactGA from "react-ga";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import H2 from "../../components/h2";
import P from "../../components/p";
import Button from "../../components/button";
import "./style.css";

const ReactButton = paypal.Button.driver("react", { React, ReactDOM });

const paymentOptions = {
  // client: {
  //   sandbox:
  //     "ASJpEnxWPeEMDVKBD4y6crXygIyuyf-87oCcVN3L1Z-dK-DSl7RexNX04np9KKr43V41JJpQvcEW-VsM"
  // },
  env: "production", // Or 'production'
  // Set up the payment:
  // 1. Add a payment callback
  payment: (data, actions) => {
    // 2. Make a request to your server
    return actions.request
      .post(
        "https://us-central1-project-1029735015520686877.cloudfunctions.net/cyclonePayment"
      )
      .then(function (res) {
        // 3. Return res.id from the response
        return res.id;
      })
      .catch((err) => console.log(err));
  },
  style: {
    size: "responsive",
    label: "buynow",
    branding: "true",
  },
};

const handleAffiliateCookie = () => {
  const affiliateCookie = localStorage.getItem("ghastaffiliate");
  if (affiliateCookie) {
    const parsedCookie = JSON.parse(affiliateCookie);
    if (new Date().getTime() <= parsedCookie.expiresAt) {
      return parsedCookie.aid;
    } else {
      localStorage.removeItem("ghastaffiliate");
    }
  }

  return null;
};

class CycloneCheckout extends React.PureComponent {
  // componentDidMount() {
  //   this.trustyPilotion();
  // }

  // componentWillReceiveProps(newProps) {
  //   if (
  //     newProps.loggedIn !== this.props.loggedIn ||
  //     newProps.premium !== this.props.premium
  //   ) {
  //     this.trustyPilotion();
  //   }
  // }

  // trustyPilotion = () => {
  //   const quotes = document.getElementById("trustpilot-checkout-quotes");
  //   const loadFromElement = () => {
  //     if (quotes && window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(quotes);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // };

  render() {
    const { premium, loggedIn, signInWithGoogle, user } = this.props;

    if (!loggedIn) {
      return (
        <Main>
          <Box>
            <H1>Sign In to Continue</H1>
            <P>You must sign in to continue</P>
            <Button onClick={signInWithGoogle}>SIGN IN</Button>
          </Box>
        </Main>
      );
    }

    if (!premium) {
      return (
        <Main>
          <Box>
            <H1>Sorry</H1>
            <P>You need to be a premium Ghast member to buy Cyclone add-on</P>
          </Box>
        </Main>
      );
    }

    if (user.cyclone === "true") {
      return (
        <Main>
          <Box>
            <H1>Thanks</H1>
            <P>You have Cyclone!</P>
            {/* <Button href="/download">DOWNLOAD</Button> */}
          </Box>
        </Main>
      );
    }

    return (
      <Main>
        <Helmet>
          <title>Checkout | Cyclone</title>
          <meta
            name="description"
            content="Ready to Buy? Proceed with the Checkout process here"
          />
        </Helmet>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <H1>Payment</H1>
          <P>Ghast is operated by AuraSide, Inc., an American corporation.</P>

          <table className="checkout-table">
            <tr>
              <th>Order summary</th>
              <th>Order Total</th>
            </tr>
            <tr>
              <td>Cyclone add-on (Lifetime)</td>
              <td>
                {/* <span
                  style={{
                    textDecoration: "line-through",
                    paddingRight: "0px",
                  }}
                >
                  $7.50
                </span>{" "} */}
                $7.5
              </td>
            </tr>
          </table>

          {/* <div
            id="trustpilot-checkout-quotes"
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="54d0e1d8764ea9078c79e6ee"
            data-businessunit-id="5c3cae791aa59c0001976ef2"
            data-style-height="300px"
            data-style-width="100%"
            data-theme="light"
            data-stars="4,5"
          >
            {" "}
            <a href="https://uk.trustpilot.com/review/ghast.io" target="_blank">
              Trustpilot
            </a>{" "}
          </div> */}

          <div
            className="paypal-button actual-paypal-button"
            style={{ width: 300, marginTop: 40 }}
          >
            {/* <Button
              href={`https://us-central1-project-1029735015520686877.cloudfunctions.net/xsollaPayment?uid=${
                user.uid
              }&email=${user.email}&affiliatedBy=${handleAffiliateCookie()}`}
            >
              Proceed To Checkout
            </Button> */}
            <ReactButton
              {...paymentOptions}
              onAuthorize={(data, actions) => {
                // 2. Make a request to your server
                return actions.request
                  .post(
                    "https://us-central1-project-1029735015520686877.cloudfunctions.net/processCyclonePayment",
                    {
                      paymentID: data.paymentID,
                      payerID: data.payerID,
                      uid: user.uid,
                      aid: handleAffiliateCookie(),
                    }
                  )
                  .then(function (res) {
                    ReactGA.event({
                      category: "Purchases",
                      action: "Purchased Ghast Premium",
                      value: 10,
                    });

                    window.tp("createInvitation", {
                      referenceId: user.uid,
                      recipientEmail: user.email,
                      recipientName: user.displayName,
                      source: "InvitationScript",
                    });
                    // 3. Show the buyer a confirmation message.
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            />
            {/*}<button className="paysafebutton">
            <img src={paysafeLogo} />
          </button> */}
          </div>
          <div className="refundpolicy">
            <H2>Refund Policy</H2>
            <P>
              You have the right to a full refund within 7 days of purchase,
              after that period you are not entitled to any refund.
            </P>
          </div>
        </div>
      </Main>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.auth.authenticated,
  premium: state.premium,
  user: state.user,
});

const mapDispatchToProps = {
  ...authActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CycloneCheckout);



/** WEBPACK FOOTER **
 ** ./src/views/pages/cycloneCheckout/index.js
 **/